import ActionViewConstructor, { ActionView } from "csi/action/ActionView";
import CsiFormData from "csi/action/FormData";
import Tab from "csi/def/Tab";
import { create } from "csi/def/ViewFactory";
import NewFrom from "csi/table/NewFrom";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import declare from "dojo/_base/declare";
import lang from "dojo/_base/lang";

const SELECT_FOOD_LABEL_PAGE = 0;
const SELECT_ITEMS_PAGE = 1;

const NewFromFoodLabelItem = declare([NewFrom, ActionControllerMixin], {

	fromTemplate: false,
	itemsViewId: null,

	/**
	 *@override
	 * Determine whether the food label is owned by Food, Formulated Material, Material, or Style
	 */
	 getFoodLabelViewId() {
		if (this.fromTemplate) {
			return "FoodLabelDataSheetTemplates";
		} 
		const ctx = this.getContext();
		let parent = ctx.cache.getPathNode(this.getParent(), "Child:__Parent__/Child:__Parent__");
		if (parent.$Type === "RecipeDataSheet") {
			parent = ctx.cache.getPathNode(parent, "Child:__Parent__");
		}
		if (parent.$Type === "Style") {
			return "FoodLabelDataSheetsUnderStyle";
		}
		if (parent.$Type === "Material") {
			return "FoodLabelDataSheetsUnderMaterial";
		}
		return (parent.$Type === "Food" || parent.$Type === "FoodBOM") ? "FoodLabelDataSheets" : "FoodLabelDataSheetsUnderFormulatedMaterial";
	},

	onWizardViewCreate(wizard, page, view) {
		if (wizard.getIndexOfPage(page) === SELECT_FOOD_LABEL_PAGE) {
			this.applyActionFilters(view);
		}
	},

	getActionView(vr): ActionView {
		const defView = create(null, "Wizard", "FoodLabelDataSheetRevision");
		defView.tabs = [
			lang.mixin(new Tab(), { m_idView: this.getFoodLabelViewId(), m_url: "centric://REFLECTION/INSTANCE/_CS_Data/null" }),
			lang.mixin(new Tab(), { m_idView: this.itemsViewId, m_url: null, m_path: "Child:CurrentRevision" }),
		];
		return new ActionViewConstructor(this, defView);
	},

	/**
	 *@override
	 * Prepare the data and pass it into the next page
	 */
	onNextPage(wizard, currentPage, nextPage, bFinish) {
		const nPage = wizard.getIndexOfPage(nextPage);
		var fd = this.m_formData;
		var bRefresh = false;

		if (nPage === SELECT_FOOD_LABEL_PAGE) {
			fd = new CsiFormData(this);
			fd.m_bOmitSelections = true;
			fd.m_bRequireOne = true;
			fd.m_bSelectOne = true;
			fd.setNode(wizard.getViewNode());
		} else if (nPage === SELECT_ITEMS_PAGE) {
			// Entering the section items table
			var foodLabelNode = wizard.getFormDataFromPage(currentPage).getSelectedNode();

			// reuse already exist form data if user used back button
			fd = wizard.getFormDataFromPage(nextPage) || wizard.defView.m_formData;

			// if form data node has changed, then reset selections and refresh view
			if (fd.getNode() != foodLabelNode) {
				fd.resetSelections();
				fd.setNode(foodLabelNode);
				bRefresh = true;
			}
		}

		// set form data for next page in wizard and refresh view if necessary
		return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, bRefresh) : null;
	},
});

export = NewFromFoodLabelItem;
